export const ENABLE_DISPLAY_MACRONS = "enable-display-macrons";
export const ENABLE_SEARCH_ALIAS = "enable-search-alias";
